module.exports = __webpack_public_path__ + "img/circle-book-open.d949186e.svg";